<template>
  <div class="relative-position">
    <slot></slot>
    <q-inner-loading :showing="showing">
      <q-spinner color="primary" size="3em" :thickness="2" />
    </q-inner-loading>
  </div>
</template>
<script>
export default {
  props: {
    showing: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
